import{multicast as r}from"./multicast.js";import{refCount as t}from"./refCount.js";import{Subject as n}from"../Subject.js";function o(){return new n}function u(){return function(n){return t()(r(o)(n))}}export{u as share};
